<template>
  <el-table-column
    prop="last_name"
    label="Név"
    sortable="custom"
    min-width="200"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      <el-button type="text" @click="$router.replace('/users/view/' + scope.row.id)">{{ scope.row.last_name }} {{
        scope.row.first_name }}
      </el-button>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'last_name',
};
</script>
